import * as React from 'react';

import classNames from 'classnames';

import {RichTextarea} from '../../rich-textarea/rich-textarea';

import {generateTextAreaConfig} from './helpers';
import {QuoteTextAreaToolbar} from './quote-text-area-toolbar';

import styles from './quote-text-area.module.css';

type Props = {
    value: string;
    onChange: (value: string) => void;
    showToolbar?: boolean;
    largerText?: boolean;
    placeholder?: string;
    padding?: 8 | 16;
    backgroundColor?: 'white';
    bottomPaddingForToolbar?: boolean;
    textAlignCenter?: boolean;
    isFullHeight?: boolean;
    autoFocus?: boolean;
};

const TOOLBAR_ID = 'quotes-text-area-toolbar';

export function QuoteTextArea(props: Props) {
    const {showToolbar = true, isFullHeight = true, autoFocus = true} = props;

    const configInput = showToolbar === false ? undefined : TOOLBAR_ID;

    const localStyles = classNames(styles['quote-text-area'], {
        [styles['quote-text-area--pad-16']]: props.padding === 16 || !props.padding,
        [styles['quote-text-area--pad-8']]: props.padding === 8,
        [styles['quote-text-area--background-white']]: props.backgroundColor === 'white',
        [styles['quote-text-area--toolbar-spacer']]: showToolbar,
    });

    return (
        <div className={localStyles}>
            <RichTextarea
                id='quotes-text-area'
                value={props.value}
                onChange={props.onChange}
                readOnly={false}
                noPadding={true}
                isFullHeight={isFullHeight}
                overflowVisible={false}
                // @ts-expect-error
                config={generateTextAreaConfig(configInput)}
                placeholder={props.placeholder}
                toolbarComponent={
                    showToolbar === false ? null : <QuoteTextAreaToolbar id={TOOLBAR_ID} />
                }
                noPlaceholderSpacing={true}
                bottomPaddingForToolbar={props.bottomPaddingForToolbar}
                largerText={props.largerText}
                textAlignCenter={props.textAlignCenter}
                autoFocus={autoFocus}
            />
        </div>
    );
}
